/**
 * Team inboxes: one row per team the agent belongs to, each a lens on the
 * conversations assigned to that team. Rows arrive pre-sorted by the shared
 * teams sort preference and carry the team's unread count. Hidden entirely
 * when the agent belongs to no team - an empty section is noise, not signal.
 */
export default ({ t, accountScopedRoute, sortedTeams, getTeamUnreadCount }) => {
  if (!sortedTeams.length) return null;

  return {
    name: 'Team Inboxes',
    label: t('SIDEBAR.TEAM_INBOXES'),
    icon: 'i-ph-users-three',
    children: sortedTeams.map(team => ({
      name: `Team ${team.id}`,
      label: team.name,
      icon: 'i-ph-users',
      badgeCount: getTeamUnreadCount(team.id),
      to: accountScopedRoute('team_conversations', { teamId: team.id }),
      activeOn: ['conversations_through_team'],
    })),
  };
};
